import React from 'react';
import { Link } from '@tanstack/react-router';

import type { Share } from '../../../types/share';

const DashboardAdminShare: React.FC<{ share: Share }> = ({ share }) => {
  return (
    <tr className="dashboard-admin-share">
      <td>{share.sent_at}</td>
      <td>{share.email}</td>
      <td>{share.name}</td>
      <td>
        <Link to={share.memory?.url || '#'} target="_blank">
          {share.memory?.title || 'N/A'}
        </Link>
      </td>
      <td>
        {share.timeline && (
          <Link to={share.timeline.url} target="_blank">
            {share.timeline.dedicated_to || 'N/A'}
          </Link>
        )}
      </td>
      <td>{share.views_count}</td>
      <td className="actions">
        <div className="wa-cluster wa-gap-2xs">
          <Link to="#delete" id={`share-${share.id}-delete`} onClick={(e) => { e.preventDefault(); }}>
            <i className="fa-light fa-trash" />
          </Link>
          <wa-tooltip for={`share-${share.id}-delete`} placement="top">
            Delete share
          </wa-tooltip>
        </div>
      </td>
    </tr>
  );
}

export default DashboardAdminShare;
